import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Product } from "src/app/routes/catalog/models/product.model";
import { Category } from "src/app/routes/catalog/models/category.model";
import { Page } from "../models/page.model";

@Injectable({
  providedIn: "root",
})
export class UrlService {
  get(item: Category | Product | Page, full = false) {
    // if (item) {
    let url = "/" + item.slug;

    if (item.parent && !this.isCategory(item) && !this.isProduct(item)) {
      url = this.get(item.parent) + url;
    }

    if (this.isCategory(item) || this.isProduct(item)) {
      url = "/location" + url;
    }

    return full ? `${environment.fullUrl}${url}` : url;
    // }
  }

  isCategory(item: Category | Product | Page) {
    return item.entity === "category";
  }

  isProduct(item: Category | Product | Page) {
    return item.entity === "product";
  }

  isPage(item: Category | Product | Page) {
    return item.entity === "page";
  }
}
